<script>
    import { flip } from 'svelte/animate';
    export let tabs = ['left', 'right'];
    export let value = 0;
    export let styling = '';

    let range = [...Array(tabs.length).keys()];
    function update(newValue) {
        value = newValue;
        range = range.filter(item => item !== 0);
        range.splice(value, 0, 0);
    }
</script>

<div class="text-gray-800 font-bold focus:outline-none rounded bg-gray-300 w-full relative shadow-lg {styling}">
    <div class="h-full w-full flex absolute p-1">
        {#each range as tab, index (tab)}
            <div animate:flip={{duration: 200}} class="z-0 flex-1 rounded {tab === 0 ? 'bg-red-500' : 'bg-transparent'}"> &nbsp </div>
        {/each}
    </div>
    <div class="w-full flex">
        {#each tabs as tab, index}
            <button class="z-10 flex-1 text-gray-800 py-2 font-bold focus:outline-none bg-transparent" on:click={() => update(index)}>
                {tab}
            </button>
        {/each}
    </div>
</div>
